import { Api } from './model';

const API_VERSION_MAP: { [version: string]: Api } = {
  v1: {
    get: {
      cashierPaymentMethods: 'api/v1/cashier/payment-methods',
      paymentInfo: 'api/v1/cashier/payment',
    },
    post: {
      uploadFile:
        '/api/v1/cashier/payment/:transactionId/document/:documentType',
      cashierMain: 'api/v1/cashier',
      externalProcessTransaction: 'api/v1/cashier/payment/process',
      registerPayment: 'api/v1/cashier/payment/register',
    },
    put: {
      confirmRequest: 'api/v1/cashier/payment/confirm',
    },
  },
  v2: {
    get: {
      cashierPaymentMethods: 'api/v1/cashier/payment-methods',
      paymentInfo: 'api/v1/cashier/payment',
    },
    post: {
      uploadFile:
        '/api/v1/cashier/payment/:transactionId/document/:documentType',
      cashierMain: 'cashier/v2',
      externalProcessTransaction: 'cashier/v2/payment/process',
      registerPayment: 'cashier/v2/payment/register',
    },
    put: {
      confirmRequest: 'cashier/v2/payment/confirm',
    },
  },
};

export const ApiResolver = {
  byVersion: (version: string): Api => {
    if (version in API_VERSION_MAP) {
      return API_VERSION_MAP[version];
    }

    return API_VERSION_MAP['v1'];
  },
};
